import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchInitiativeTypesAction, saveInitiativeTypeAction} from '../actions/';
import InitiativeTypesPage from '../components/InitiativeTypes/InitiativeTypesPage';

class InitiativeTypesContainer extends Component {
  render() {
    const { actions } = this.props;
    const {initiativeTypes} = this.props;
    const { typeId } = this.props.params;

    return <InitiativeTypesPage actions={actions} initiativeTypes={initiativeTypes} typeId={typeId}/>;
  }

  componentWillMount (){
     const { actions } = this.props;
     actions.fetchInitiativeTypesAction(true);
  }

  

}

InitiativeTypesContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {initiativeTypes : state.initiativeTypes};
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchInitiativeTypesAction, saveInitiativeTypeAction};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(InitiativeTypesContainer);



// WEBPACK FOOTER //
// ./containers/InitiativeTypesContainer.js